import { y1, y2, y3, y4, y5, y6 } from "../../helper/writingMatrices";
import { MappixLevels, YearString } from "../../helper";

export const ActualOutcome = (studentData, currentYear) => {

  let studentOutcome = "";
  switch (currentYear) {
  case YearString.Year1:
    if (CheckMatrxEquality(CompareMatrices(y1.G, studentData), studentData)) { studentOutcome = MappixLevels.OneGreaterThanExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y1.E, studentData), studentData)) { studentOutcome = MappixLevels.OneExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y1.W, studentData), studentData)) { studentOutcome = MappixLevels.OneWorkingTowards; }
    else { studentOutcome = MappixLevels.OneBelow; }
    break;
  case YearString.Year2:
    if (CheckMatrxEquality(CompareMatrices(y2.G, studentData), studentData)) { studentOutcome = MappixLevels.TwoGreaterThanExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y2.E, studentData), studentData)) { studentOutcome = MappixLevels.TwoExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y2.W, studentData), studentData)) { studentOutcome = MappixLevels.TwoWorkingTowards; }
    else { studentOutcome = MappixLevels.TwoBelow; }
    break;
  case YearString.Year3:
    if (CheckMatrxEquality(CompareMatrices(y3.G, studentData), studentData)) { studentOutcome = MappixLevels.ThreeGreaterThanExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y3.E, studentData), studentData)) { studentOutcome = MappixLevels.ThreeExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y3.W, studentData), studentData)) { studentOutcome = MappixLevels.ThreeWorkingTowards; }
    else { studentOutcome = MappixLevels.ThreeBelow; }
    break;
  case YearString.Year4:
    if (CheckMatrxEquality(CompareMatrices(y4.G, studentData), studentData)) { studentOutcome = MappixLevels.FourGreaterThanExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y4.E, studentData), studentData)) { studentOutcome = MappixLevels.FourExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y4.W, studentData), studentData)) { studentOutcome = MappixLevels.FourWorkingTowards; }
    else { studentOutcome = MappixLevels.FourBelow; }
    break;
  case YearString.Year5:
    if (CheckMatrxEquality(CompareMatrices(y5.G, studentData), studentData)) { studentOutcome = MappixLevels.FiveGreaterThanExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y5.E, studentData), studentData)) { studentOutcome = MappixLevels.FiveExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y5.W, studentData), studentData)) { studentOutcome = MappixLevels.FiveWorkingTowards; }
    else { studentOutcome = MappixLevels.FiveBelow; }
    break;
  case YearString.Year6:
    if (CheckMatrxEquality(CompareMatrices(y6.G, studentData), studentData)) { studentOutcome = MappixLevels.SixGreaterThanExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y6.E, studentData), studentData)) { studentOutcome = MappixLevels.SixExpected; }
    else if (CheckMatrxEquality(CompareMatrices(y6.W, studentData), studentData)) { studentOutcome = MappixLevels.SixWorkingTowards; }
    else { studentOutcome = MappixLevels.SixBelow; }
    break;
  default: break;
  }
  return { studentOutcome }

}

const CompareMatrices = (objMatrix, studentMatrix) => {
  const numRows = objMatrix.length;
  const numCols = objMatrix[0].length;
  const resultMatrix = [];

  for (let i = 0; i < numRows; i++) {
    const row = [];
    for (let j = 0; j < numCols; j++) {
      row.push(CompareValues(objMatrix[i][j], studentMatrix[i][j]));
    }
    resultMatrix.push(row);
  }
  return resultMatrix;
}


const CompareValues = (a, b) => {
  return a && b;
}

const CheckMatrxEquality = (ResMatrix, StdMatrix) => {
  for (let i = 0; i < ResMatrix.length; i++) {
    for (let j = 0; j < ResMatrix[i].length; j++) {
      if (!(StdMatrix[i][j] === ResMatrix[i][j])) {
        return false;
      }
    }
  }
  return true;
}